import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ClerkProvider } from '@clerk/clerk-react';
import CustomHTML from './CustomHTML';
import PrivacyPolicy from './PrivacyPolicy';
import TermsOfService from './TermsOfService';
import SignupPage from './SignupPage';
import DashboardPlaceholder from './DashboardPlaceholder';
import './App.css';

const clerkPubKey = process.env.REACT_APP_CLERK_PUBLISHABLE_KEY;

if (!clerkPubKey) {
  throw new Error("Missing Clerk Publishable Key");
}

const App = () => {
  // Set default page title
  useEffect(() => {
    document.title = "StudioIQ - Jewelry Repair + Restoration Pricing Technology";
  }, []);

  return (
    <ClerkProvider 
      publishableKey={clerkPubKey}
      allowedRedirectOrigins={['https://studioiq.app']}
      signInForceRedirectUrl={process.env.REACT_APP_CLERK_SIGN_IN_FORCE_REDIRECT_URL}
      signUpForceRedirectUrl={process.env.REACT_APP_CLERK_SIGN_UP_FORCE_REDIRECT_URL}
      signInFallbackRedirectUrl={process.env.REACT_APP_CLERK_SIGN_IN_FALLBACK_REDIRECT_URL}
      signUpFallbackRedirectUrl={process.env.REACT_APP_CLERK_SIGN_UP_FALLBACK_REDIRECT_URL}
    >
      <Router>
        <div className="App">
          <Routes>
            <Route path="/" element={<CustomHTML />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/terms-of-service" element={<TermsOfService />} />
            <Route path="/signup" element={<SignupPage />} />
            <Route path="/get-started" element={<SignupPage />} />
            <Route path="/dashboard" element={<DashboardPlaceholder />} />
          </Routes>
        </div>
      </Router>
    </ClerkProvider>
  );
};

export default App;